import { Box, Divider } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import EntryProofIcon from '../../examRegistration/components/EntryProofIcon';
import {
  EntryProofDownloadModel,
  SubjectAmendmentSummaryResponse,
} from '../../../api/candidate/exam/model';
import FormHeader from '../../../components/form-items/FormHeader';
import { RegistrationType } from '../../../api-refactored/entry-proof/useGetDownloadEntryProof';

const EntryProofDownload = ({
  summary,
  classes,
}: {
  summary?: SubjectAmendmentSummaryResponse;
  classes: any;
}) => {
  const { t } = useTranslation();
  const entryProofRender = () => {
    const entryProofLength = summary?.entryProofDownloadModels?.length;
    switch (true) {
      case entryProofLength === 0: {
        return <Box className={classes.entryProofContainer}>-</Box>;
      }
      case entryProofLength === 1: {
        // @ts-ignore
        const entryProof = summary?.entryProofDownloadModels?.[0];

        if (!entryProof || entryProof.fileName === null) {
          return <Box className={classes.entryProofContainer}>-</Box>;
        }
        return (
          <EntryProofIcon
            fileName={entryProof.fileName}
            uuid={entryProof.uuid}
            registrationType={RegistrationType.NATIONAL}
          />
        );
      }
      case (entryProofLength as number) > 1: {
        if (
          summary?.entryProofDownloadModels?.every(
            (entryProof: EntryProofDownloadModel) => entryProof.fileName === null
          )
        ) {
          return <Box className={classes.entryProofContainer}>-</Box>;
        }
        return summary?.entryProofDownloadModels?.map((entryProof: EntryProofDownloadModel) => {
          if (entryProof.fileName === null) {
            return null;
          }
          return (
            <EntryProofIcon
              fileName={entryProof.fileName}
              uuid={entryProof.uuid}
              key={entryProof.uuid}
              registrationType={RegistrationType.NATIONAL}
            />
          );
        });
      }
      default: {
        return null;
      }
    }
  };

  return (
    <>
      <Box className={classes.divider}>
        <Divider />
      </Box>
      <FormHeader title={t('exam->>RegistrationSummary.EntryProof')} />
      {entryProofRender()}
      <Box className={classes.divider}>
        <Divider />
      </Box>
    </>
  );
};

export default EntryProofDownload;
